import React, { useEffect, useRef, useState } from "react";
import Sectional from './collection/Sectional'
import { cn } from '../lib/utils'

const Sidebar = (props) => {
  // const [activeTab, setActiveTab] = useState("");
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(-1);
  const [selectedCollectionIndex, setSelectedCollectionIndex] = useState(-1);

  function setTab(name) {
    console.log(name)
    props.setActiveTab(el => {
      const e = el === name ? "" : name;
      return (
        e
      )
    })
  }

  const sidebarRef = useRef(null);

  const onClose = () => {
    props.setActiveTab("");
  };

  // Close panel if click occurs outside of it
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
  //       props.setActiveTab("");
  //     }
  //   };

  //   // Attach event listener
  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     // Clean up event listener on component unmount
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);



  return (
    <div ref={sidebarRef}>

      {/* ------------------Close Button------------------- */}
      {props.activeTab && <button
        onClick={onClose}
        className="absolute z-[2] md:hidden top-4 left-4 bg-white text-black hover:text-gray-800 p-1 px-2"
      >
        ✖
      </button>}

      {/* -------------------- blur div -------------------------- */}
      {
        props.activeTab && <div className='fixed w-full h-full top-0 left-0 bg-white md:bg-none bg-opacity-50 backdrop-blur-lg md:hidden' >

        </div>
      }

      <div className="w-auto h-full fixed z-[3] right-0 md:relative flex flex-row z-50">
        {/*---------------- Header Tabs--------------------*/}
        <div className={cn("flex flex-col border-r border-black", props.activeTab ? "" : "mr-1")}>
          <button
            className={`py-8 pl-1 mx-auto text-center border border-r-0 border-black font-NeueMTL [writing-mode:vertical-lr] ${props.activeTab === "config"
              ? "bg-black text-white"
              : "hover:bg-gray-200"
              }`}
            onClick={() => setTab("config")}
          >
            configurations
          </button>
          {/* <button
            className={`py-8 pl-1 mx-auto text-center border  border-r-0 border-black  [writing-mode:vertical-lr] ${activeTab === "fabric" ? "bg-black text-white" : "hover:bg-gray-200"
              }`}
            onClick={() => setActiveTab("fabric")}
          >
            tissus
          </button> */}
        </div>

        {/*--------------- Collection Content-------------------- */}
        {
          <div className={cn("flex flex-col overflow-y-auto bg-white w-[220px] max-w-[220px] transition-all duration-500", props.activeTab ? "" : "mr-[-220px]")}>
            {/* {props.activeTab === "fabric" && <Collection data={fabricCollections} selectedIndex={selectedCollectionIndex} select={setSelectedCollectionIndex} />} */}
            {props.activeTab === "config" && <Sectional allModels={props.allModels} isBothMode={props.isBothMode} iframe={props.iframe} db={props.db} collection={props.collection} selectedIndex={props.currModel} select={props.setCurrModel} />}
          </div>
        }
      </div>
    </div>

  );
};

export default Sidebar;
